import { MultiplePermissions } from '@firebird-web/acl';

export const FORECAST_COMMENTARY_DETAILED_DISCUSSION_MULTIPLE_PERMISSIONS: MultiplePermissions =
  [
    ['Forecaster_Discussions', '1_to_5_Day', 'NA'],
    ['Forecaster_Discussions', '1_to_5_Day', 'EUR'],
    ['Forecaster_Discussions', 'Medium_Range', 'NA'],
    ['Forecaster_Discussions', 'Medium_Range', 'EUR'],
  ];

export const PERIOD_MAPS_HEADLINES_MULTIPLE_PERMISSIONS: MultiplePermissions = [
  ['Headlines', 'NA'],
  ['Headlines', 'EUR'],
  ['Headlines', 'ASIA'],
  ['Headlines', 'MEX'],
];
